<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @before-open="beforeOpen"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-refresh" :loading="pulling" @click="handlePull">
          手动拉取
        </el-button>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-data-line" @click="openHistory(row)">
          历史
        </el-button>
      </template>
    </avue-crud>

    <el-dialog title="测点历史" :visible.sync="historyVisible" width="900px" append-to-body>
      <avue-crud
        :option="historyOption"
        :data="historyData"
        :page.sync="historyPage"
        :table-loading="historyLoading"
        @current-change="historyCurrentChange"
        @size-change="historySizeChange"
      />
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getList, getDetail, add, update, remove, pull, getHistory } from '@/api/env-monitor/point'

export default {
  name: 'env-monitor-point',
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, getDetail, add, update, remove },
      pulling: false,
      historyVisible: false,
      historyLoading: false,
      currentHistoryRow: null,
      historyData: [],
      historyPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      historyOption: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: false,
        column: [
          { label: '测点编号', prop: 'pointCode', minWidth: 130 },
          { label: '采集值', prop: 'collectValue', minWidth: 100 },
          { label: '单位', prop: 'unit', width: 80 },
          { label: '报警状态', prop: 'alarmStatus', width: 100, type: 'select', dicData: [{ label: '正常', value: 0 }, { label: '报警', value: 1 }] },
          {
            label: '测点状态',
            prop: 'pointStatus',
            width: 110,
            type: 'select',
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=env_monitor_point_status',
            props: { label: 'dictValue', value: 'dictKey' }
          },
          { label: '采集时间', prop: 'collectTime', type: 'datetime', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss', minWidth: 170 }
        ]
      },
      option: {
        ...this.$store.state.publicOption,
        dialogWidth: '900px',
        viewBtn: true,
        column: [
          { label: '分站编号', prop: 'stationCode', search: true, minWidth: 120 },
          { label: '测点编号', prop: 'pointCode', search: true, minWidth: 120, rules: [{ required: true, message: '请输入测点编号', trigger: 'blur' }] },
          { label: '测点名称', prop: 'pointName', search: true, minWidth: 180 },
          { label: '检测类型', prop: 'monitorType', search: true, minWidth: 100 },
          { label: '当前值', prop: 'currentValue', type: 'number', precision: 6, minWidth: 100, addDisplay: false, editDisplay: false },
          { label: '单位', prop: 'unit', width: 80 },
          { label: '报警值', prop: 'alarmValue', type: 'number', precision: 6, hide: true },
          { label: '断电值', prop: 'powerOffValue', type: 'number', precision: 6, hide: true },
          { label: '复电值', prop: 'powerOnValue', type: 'number', precision: 6, hide: true },
          { label: '断电命令', prop: 'powerOffCommand', hide: true },
          { label: '复电命令', prop: 'powerOnCommand', hide: true },
          { label: '关联设备ID', prop: 'deviceId', search: true, minWidth: 140 },
          { label: '关联设备名称', prop: 'deviceName', search: true, minWidth: 150 },
          { label: '报警状态', prop: 'alarmStatus', search: true, width: 100, type: 'select', dicData: [{ label: '正常', value: 0 }, { label: '报警', value: 1 }] },
          {
            label: '测点状态',
            prop: 'pointStatus',
            search: true,
            width: 110,
            type: 'select',
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=env_monitor_point_status',
            props: { label: 'dictValue', value: 'dictKey' }
          },
          { label: '原始状态', prop: 'rawStatus', hide: true },
          { label: '当前报警ID', prop: 'currentAlarmRecordId', hide: true, addDisplay: false, editDisplay: false },
          { label: '最后采集时间', prop: 'lastCollectTime', type: 'datetime', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss', minWidth: 170, addDisplay: false, editDisplay: false }
        ]
      }
    }
  },
  methods: {
    handlePull() {
      this.pulling = true
      pull().then((res) => {
        const data = res.data.data || {}
        this.$message.success(data.message || '拉取完成')
        this.onLoad(this.page)
      }).finally(() => {
        this.pulling = false
      })
    },
    openHistory(row) {
      this.currentHistoryRow = row
      this.historyPage.currentPage = 1
      this.historyVisible = true
      this.loadHistory()
    },
    historyCurrentChange(currentPage) {
      this.historyPage.currentPage = currentPage
      this.loadHistory()
    },
    historySizeChange(pageSize) {
      this.historyPage.pageSize = pageSize
      this.loadHistory()
    },
    loadHistory() {
      if (!this.currentHistoryRow) return
      this.historyLoading = true
      getHistory({
        pointId: this.currentHistoryRow.id,
        page: this.historyPage.currentPage,
        size: this.historyPage.pageSize
      }).then((res) => {
        const data = res.data.data || {}
        this.historyData = data.records || []
        this.historyPage.total = data.total || 0
      }).finally(() => {
        this.historyLoading = false
      })
    }
  }
}
</script>
